import {
  api as generatedApi,
  CurrentTimeDocument,
} from './operations.generated';
import type { CurrentTimeQuery } from './operations.generated';

/**
 * Milliseconds between local clock and server at response time.
 * Matches legacy OG getClockDrift transformResponse.
 */
const toClockDriftMs = (response: CurrentTimeQuery): number =>
  Date.now() - response.Users.currentTime.ts;

const tenantUserListTag = { type: 'TenantUser' as const, id: 'LIST' };

export const tenantUsersProvidesTags = (
  result: { Users?: { tenantUsers: Array<{ id: string }> } } | undefined,
) => {
  if (result?.Users?.tenantUsers) {
    return [
      ...result.Users.tenantUsers.map((item) => ({
        type: 'TenantUser' as const,
        id: item.id,
      })),
      tenantUserListTag,
    ];
  }
  return [tenantUserListTag];
};

const apiWithInjectedEndpoints = generatedApi.injectEndpoints({
  endpoints: (build) => ({
    GetClockDrift: build.query<number, void>({
      query: () => ({ document: CurrentTimeDocument }),
      transformResponse: toClockDriftMs,
    }),
  }),
});

export const api = apiWithInjectedEndpoints.enhanceEndpoints({
  addTagTypes: ['TenantUser', 'TenantRoom'],
  endpoints: {
    UpdateUserProfile: {
      invalidatesTags: ['TenantRoom'],
    },
    GetTenantUsers: {
      providesTags: tenantUsersProvidesTags,
    },
    GetTenantUsersWithRoles: {
      providesTags: tenantUsersProvidesTags,
    },
  },
});
export const {
  useGetTenantUsersQuery,
  useLazyGetTenantUsersQuery,
  useGetTenantUsersWithRolesQuery,
  useLazyGetTenantUsersWithRolesQuery,
  useLazyAccountSetupStatusQuery,
  useCurrentTimeQuery,
  useGetClockDriftQuery,
  useIsOgClinicUserQuery,
} = api;

export const {
  endpoints: { CannyToken: getCannyToken, GetClockDrift: getClockDrift },
} = api;
